import "./assets/css/style.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import useStore from "./store/store";
import Home from "./views/home/Home";
import Loading from "./components/Loading";
import Signup from "./views/auth/Signup";
import Login from "./views/auth/Login";
import Profile from "./views/user/Profile";
import Navbar from "./components/Navbar";
import ToastError from "./components/ToastError";
import ToastSuccess from "./components/ToastSuccess";
import ToastInfo from "./components/ToastInfo";
import Header from "./components/Header";
import ChangePassword from "./views/user/ChangePassword";
import Setting from "./views/user/Setting";
import Stock from "./views/items/List";
import Users from "./views/users/List";
import Account from "./views/account/Account";
import Transaction from "./views/transaction/Transaction";
import TrialBalance from "./views/trial/TrialBalance";
import TransactionHistory from "./views/trial/TransactionHistory";
import AboutUs from "./views/about/About-us";
import Bills from "./views/bills/Bill";
import BillDetails from "./views/bills/BillDetails";
import Chart from "./views/chart/TransactionChart";

function App() {
  const {
    isLoading,
    isLoggedIn,
    user,
    token,
    errorMessage,
    setErrorMessage,
    successMessage,
    setSuccessMessage,
    infoMessage,
    setInfoMessage,
  } = useStore((state) => state);
  return (
    <Router>
      {isLoading === true && <Loading />}
      <ToastError
        open={errorMessage?.length > 0}
        onClose={() => setErrorMessage("")}
        body={errorMessage}
      />
      <ToastSuccess
        open={successMessage?.length > 0}
        onClose={() => setSuccessMessage("")}
        body={successMessage}
      />
      <ToastInfo
        open={infoMessage?.length > 0}
        onClose={() => setInfoMessage("")}
        body={infoMessage}
      />
      <Header />
      <div className="container">
        <div className="routes">
          <Routes>
            <Route
              exact
              path="/"
              element={isLoggedIn && token ? <Account /> : <Login />}
            />
            <Route exact path="/signup" element={<Signup />} />
            <Route exact path="/login" element={<Login />} />
            <Route exact path="/changePassword" element={<ChangePassword />} />
            <Route exact path="/profile" element={<Profile />} />
            <Route exact path="/settings" element={<Setting />} />
            <Route exact path="/stocks" element={<Stock />} />
            <Route exact path="/users" element={<Users />} />
            <Route exact path="/about-us" element={<AboutUs />} />
            <Route exact path="/accounts" element={<Account />} />
            <Route exact path="/transactions" element={<Transaction />} />
            <Route exact path="/bills" element={<Bills />} />
            <Route exact path="/chart" element={<Chart />} />
            <Route exact path="/bill-details" element={<BillDetails />} />
            <Route exact path="/trial-balance" element={<TrialBalance />} />
            <Route
              exact
              path="/transaction-history/:id"
              element={<TransactionHistory />}
            />
          </Routes>
        </div>
      </div>
      {isLoggedIn && user && <Navbar />}
    </Router>
  );
}

export default App;
